var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { float: "left" } },
        [
          _vm.filtrosAplicados.length > 0
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { "data-cy": "setFilters" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.setFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: {
                      icon: "search",
                      color: "primary",
                      badge: _vm.filtrosAplicados.length
                    }
                  }),
                  _c("strong", [_vm._v("Buscar")])
                ],
                1
              )
            : _vm._e(),
          !_vm.filtrosAplicados.length
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { color: "gray" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.setFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", { attrs: { icon: "search", color: "#ccc" } }),
                  _c(
                    "strong",
                    { attrs: { "data-cy": "search-without-filters" } },
                    [_vm._v("Buscar sin filtros aplicados ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.hasQueryFilters
            ? _c(
                "vs-chip",
                {
                  staticStyle: { cursor: "context-menu" },
                  attrs: { color: _vm.colores.navbar },
                  nativeOn: {
                    click: function($event) {
                      return _vm.clearQueryFilters()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: { icon: "link", color: "primary" }
                  }),
                  _c("strong", [_vm._v("Borrar filtros de enlace")])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            float: "right",
            display: "flex",
            "align-items": "center"
          }
        },
        [
          _vm.mostrarDescarga
            ? _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Descargar como CSV",
                      expression: "'Descargar como CSV'"
                    }
                  ],
                  staticStyle: { cursor: "pointer", "margin-left": "10px" },
                  attrs: { color: "primary", "data-cy": "download-list" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.downloadTray()
                    }
                  }
                },
                [
                  _c("vs-avatar", {
                    attrs: { color: "primary", icon: "file_download" }
                  }),
                  _vm._v(" Descargar ")
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-dropdown",
            { attrs: { "vs-trigger-click": "", "data-cy": "add-filter" } },
            [
              _c(
                "vs-chip",
                { attrs: { color: "primary" } },
                [
                  _c("vs-avatar", { attrs: { icon: "add", color: "primary" } }),
                  _vm._v(" Agregar filtro ")
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                { staticClass: "scroll-options", attrs: { "data-cy": "list" } },
                [
                  _vm.filtrosDisponibles.length >=
                  _vm.showFilterOnNumberElements
                    ? _c("vs-input", {
                        attrs: {
                          type: "text",
                          "data-cy": "filter-input-search"
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    : _vm._e(),
                  _vm._l(_vm.avalaibleFiltersSearch, function(filter, index) {
                    return _c(
                      "vs-dropdown-item",
                      {
                        key: "filter-" + index,
                        staticStyle: { width: "200px" },
                        attrs: { "data-cy": "filter-" + filter.campo },
                        on: {
                          click: function($event) {
                            return _vm.addFilter(filter)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(filter.nombre) + " ")]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._l(_vm.filtrosAplicadosFiltered, function(filtro, index) {
        return _c(
          "vs-chip",
          {
            key: "filtro-aplicado-" + index,
            staticStyle: { cursor: "context-menu" },
            attrs: { color: "primary", transparent: "" }
          },
          [
            _c("vs-avatar", {
              attrs: { "data-cy": "clear", icon: "clear", color: "primary" },
              nativeOn: {
                click: function($event) {
                  return _vm.removeFilter(filtro)
                }
              }
            }),
            _c("span"),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Modificar filtro " + filtro.nombre,
                    expression: "`Modificar filtro ${filtro.nombre}`"
                  }
                ],
                on: {
                  click: function($event) {
                    return _vm.modificarFiltro(filtro)
                  }
                }
              },
              [
                _c("strong", [_vm._v(_vm._s(filtro.nombre) + ": ")]),
                _c("span", { staticClass: "pl-1" }, [
                  _vm._v(" " + _vm._s(filtro.valorFormateado) + " ")
                ])
              ]
            )
          ],
          1
        )
      }),
      _c(
        "b-modal",
        {
          ref: "configFiltro",
          attrs: {
            title: "Filtrar por " + _vm.actualFilter.nombre,
            "no-close-on-backdrop": "",
            centered: "",
            "hide-footer": "",
            "hide-header-close": _vm.editMood
          },
          on: {
            cancel: function($event) {
              return _vm.closeModal(_vm.actualFilter)
            },
            close: function($event) {
              return _vm.closeModal(_vm.actualFilter)
            }
          }
        },
        [
          _c("div", [
            _vm.actualFilter.tipo === "usuarioIds"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los usuarios",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " usuarios seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            201108783
                          ),
                          model: {
                            value: _vm.filterOptions.users,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "users", $$v)
                            },
                            expression: "filterOptions.users"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "correos"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los usuarios",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " usuarios seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            201108783
                          ),
                          model: {
                            value: _vm.filterOptions.userCorreos,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "userCorreos", $$v)
                            },
                            expression: "filterOptions.userCorreos"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "derivadoIds"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los usuarios",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " usuarios seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            201108783
                          ),
                          model: {
                            value: _vm.filterOptions.derivados,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "derivados", $$v)
                            },
                            expression: "filterOptions.derivados"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "opcionDoc"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los tipos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " docs seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3972364385
                          ),
                          model: {
                            value: _vm.filterOptions.documents,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "documents", $$v)
                            },
                            expression: "filterOptions.documents"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "opcionDocRepo"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los tipos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " docs seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3972364385
                          ),
                          model: {
                            value: _vm.filterOptions.documentsDocRepo,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.filterOptions,
                                "documentsDocRepo",
                                $$v
                              )
                            },
                            expression: "filterOptions.documentsDocRepo"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "opcionInst"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los tipos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " instituciones seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3764708015
                          ),
                          model: {
                            value: _vm.filterOptions.institutions,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "institutions", $$v)
                            },
                            expression: "filterOptions.institutions"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "institutionsDD"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los tipos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " instituciones seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3764708015
                          ),
                          model: {
                            value: _vm.filterOptions.institutionsDD,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "institutionsDD", $$v)
                            },
                            expression: "filterOptions.institutionsDD"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "grupoIds" ||
            _vm.actualFilter.tipo === "oficinaIds"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los grupos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " grupos seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2650963030
                          ),
                          model: {
                            value: _vm.filterOptions.groups,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "groups", $$v)
                            },
                            expression: "filterOptions.groups"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "grupoCreador"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los grupos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " grupos seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2650963030
                          ),
                          model: {
                            value: _vm.filterOptions.groupCreator,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "groupCreator", $$v)
                            },
                            expression: "filterOptions.groupCreator"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "theme"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " opciones seleccionadas"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1429371254
                          ),
                          model: {
                            value: _vm.filterOptions.theme,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "theme", $$v)
                            },
                            expression: "filterOptions.theme"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "subTheme"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " opciones seleccionadas"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1429371254
                          ),
                          model: {
                            value: _vm.filterOptions.subTheme,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "subTheme", $$v)
                            },
                            expression: "filterOptions.subTheme"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "grupoDestino"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "select-label": "Presiona enter para seleccionar",
                            "selected-label": "Presiona enter para remover",
                            "deselect-label": "Presiona enter para remover",
                            placeholder: "Seleccione los elementos",
                            label: "nombre",
                            "track-by": "valor",
                            options: _vm.actualFilter.opciones,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            "preselect-first": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(values.length) +
                                                " elementos seleccionados"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2921313176
                          ),
                          model: {
                            value: _vm.filterOptions.groupSubject,
                            callback: function($$v) {
                              _vm.$set(_vm.filterOptions, "groupSubject", $$v)
                            },
                            expression: "filterOptions.groupSubject"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("No existen coincidencias")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo == "multi"
              ? _c(
                  "div",
                  [
                    _vm.actualFilter.valor.length == 1
                      ? _c("div", { staticClass: "alerta" }, [
                          _vm._v(
                            " Debe seleccionar como mínimo 1 de las opciones. Seleccione otra opción antes de desmarcar la actual si es que desea cambiarla. "
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "vs-checkbox",
                      {
                        staticClass: "modal-opcion",
                        nativeOn: {
                          change: function($event) {
                            return _vm.selectFilter(_vm.actualFilter)
                          }
                        },
                        model: {
                          value: _vm.selectAllOptions,
                          callback: function($$v) {
                            _vm.selectAllOptions = $$v
                          },
                          expression: "selectAllOptions"
                        }
                      },
                      [_vm._v(" Seleccionar Todos ")]
                    ),
                    _c("hr"),
                    _c("br"),
                    _vm._l(Object.entries(_vm.actualFilter.opciones), function(
                      ref
                    ) {
                      var valor = ref[0]
                      var nombre = ref[1]
                      return _c(
                        "div",
                        { key: nombre, staticClass: "modal-opcion" },
                        [
                          _c(
                            "vs-checkbox",
                            {
                              attrs: {
                                "vs-value": valor,
                                disabled:
                                  _vm.actualFilter.valor.length === 1 &&
                                  _vm.actualFilter.valor.includes(valor)
                              },
                              nativeOn: {
                                change: function($event) {
                                  return _vm.selectFilter(_vm.actualFilter)
                                }
                              },
                              model: {
                                value: _vm.actualFilter.valor,
                                callback: function($$v) {
                                  _vm.$set(_vm.actualFilter, "valor", $$v)
                                },
                                expression: "actualFilter.valor"
                              }
                            },
                            [_vm._v(" " + _vm._s(nombre) + " ")]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm.actualFilter.tipo == "texto"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("tags-input", {
                        attrs: {
                          "element-id": "tags",
                          "add-tags-on-blur": "",
                          "add-tags-on-comma": "",
                          placeholder: "Agregar",
                          typeahead: true
                        },
                        model: {
                          value: _vm.tags,
                          callback: function($$v) {
                            _vm.tags = $$v
                          },
                          expression: "tags"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo == "fecha"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "texto-normal" },
                    [
                      _c("datetime", {
                        attrs: {
                          "input-class": "input-date",
                          phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                          "value-zone": "local",
                          format: "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.actualFilter.valor,
                          callback: function($$v) {
                            _vm.$set(_vm.actualFilter, "valor", $$v)
                          },
                          expression: "actualFilter.valor"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.actualFilter.tipo === "rangoFecha"
              ? _c("div", [
                  _c("div", { staticClass: "swtich-tipo-rango" }, [
                    _c("div", { staticClass: "rango-parte" }, [
                      _vm._v("Rango Simple")
                    ]),
                    _c(
                      "div",
                      { staticClass: "rango-parte rango-switch" },
                      [
                        _c("vs-switch", {
                          model: {
                            value: _vm.tipoRangoFechaAvanzado,
                            callback: function($$v) {
                              _vm.tipoRangoFechaAvanzado = $$v
                            },
                            expression: "tipoRangoFechaAvanzado"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "rango-parte" }, [
                      _vm._v("Rango Avanzado")
                    ])
                  ]),
                  _c("br"),
                  _c("hr"),
                  _c("br"),
                  !_vm.tipoRangoFechaAvanzado
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "center" },
                          [
                            _vm._l(_vm.periodos, function(periodo, index) {
                              return [
                                _c(
                                  "vs-button",
                                  {
                                    key: "periodo-" + index,
                                    staticClass: "w-full mb-1",
                                    attrs: {
                                      disabled:
                                        periodo.valor ===
                                        _vm.actualFilter.valor,
                                      size: "medium",
                                      color: "primary",
                                      type: "filled"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.seleccionarRango(
                                          periodo.valor
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          periodo.nombre
                                            .charAt(0)
                                            .toUpperCase() +
                                            periodo.nombre.slice(1)
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticStyle: { "font-size": "80%" } },
                                      [
                                        _vm._v(
                                          " (desde el " +
                                            _vm._s(
                                              _vm.formatoTipoRango(
                                                periodo.valor,
                                                true
                                              )
                                            ) +
                                            " hasta hoy) "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm.tipoRangoFechaAvanzado
                    ? _c(
                        "div",
                        [
                          _vm._v(" entre el "),
                          _c("datetime", {
                            attrs: {
                              "input-class": "input-date",
                              phrases: {
                                ok: "Seleccionar",
                                cancel: "Cancelar"
                              },
                              "value-zone": "local",
                              format: "yyyy-MM-dd",
                              "data-cy": "start-time"
                            },
                            model: {
                              value: _vm.rangoAvanzado.desde,
                              callback: function($$v) {
                                _vm.$set(_vm.rangoAvanzado, "desde", $$v)
                              },
                              expression: "rangoAvanzado.desde"
                            }
                          }),
                          _vm._v(" y el "),
                          _c("datetime", {
                            attrs: {
                              "input-class": "input-date",
                              phrases: {
                                ok: "Seleccionar",
                                cancel: "Cancelar"
                              },
                              "value-zone": "local",
                              format: "yyyy-MM-dd",
                              "data-cy": "end-time"
                            },
                            model: {
                              value: _vm.rangoAvanzado.hasta,
                              callback: function($$v) {
                                _vm.$set(_vm.rangoAvanzado, "hasta", $$v)
                              },
                              expression: "rangoAvanzado.hasta"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "text-center mt-2" },
            [
              _c(
                "vs-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.verificarFiltrosAlCerrar }
                },
                [_vm._v(" Confirmar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }